// load scss
import './Main.scss';

import './General/Lib/CreateNamespace';
import 'waypoints/lib/jquery.waypoints.js';
import './General/Lib/jquery.mobilenavigation.js';
import 'swipebox/src/js/jquery.swipebox.js';
import './General/MixItUp';
import './General/Lib/MyFonts.noLinter.js';
import './Content/Video/Video.js';

function initWaypoints() {
    $('.menu-ending').waypoint({
        handler: function(direction) {
            $('.site__sidebar').toggleClass('sticky', direction === 'down');
            //.toggleClass('at-bottom', direction === 'up')
        },
        offset: '100%'
    });
}

function initNavigation() {
    $('.mobile-bar__menu').mobilenavigation({
        breakpoint: 768,
        back: 'Zurück'
    });

    $('.mobile-bar__menu-button').click(function() {
        $('header').toggleClass('nav-toggled');
        $(window).scrollTop(0);
    });
}

function initForms() {
    //set "notEmpty" class on startup
    $('.input--with-placeholder .input__field').each(function() {
        if ($(this).val()) {
            $(this).addClass('input__field--not-empty');
        } else {
            $(this).removeClass('input__field--not-empty');
        }
    });

    //set "notEmpty class on blur
    $('.input--with-placeholder .input__field').blur(function() {
        if ($(this).val()) {
            $(this).addClass('input__field--not-empty');
        } else {
            $(this).removeClass('input__field--not-empty');
        }
    });
}

function initSwipebox() {
    $('.swipebox,.js-swipebox').swipebox();
}

$(document).ready(function() {
    initWaypoints();
    initNavigation();
    initForms();
    initSwipebox();
});
